import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
	// viewBox="0 0 16 16"
	return (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.52 15.04H1.44C1.184 15.04 0.96 14.816 0.96 14.56V0.48C0.96 0.224 0.736 0 0.48 0C0.224 0 0 0.224 0 0.48V14.56C0 15.36 0.64 16 1.44 16H15.52C15.776 16 16 15.776 16 15.52C16 15.264 15.776 15.04 15.52 15.04Z"
				fill={color}
			/>
			<path
				d="M15.4398 10.3139C15.331 10.3139 15.2222 10.2787 15.1326 10.2019C15.0686 10.1507 13.5582 8.88026 11.795 6.13146C11.5486 5.74746 11.3438 5.32506 11.1486 4.91546C10.483 3.53626 10.051 2.76506 8.84457 2.96666C8.15977 3.08186 7.59657 3.96506 6.81897 5.19386C6.58537 5.56186 6.31977 5.98106 6.02857 6.41306C4.76457 8.27866 2.65577 9.93306 2.56617 10.0035C2.35497 10.1667 2.05417 10.1283 1.89097 9.92026C1.72777 9.71226 1.76617 9.40826 1.97417 9.24506C1.99337 9.22906 4.05417 7.60986 5.23177 5.87226C5.51657 5.44986 5.77257 5.04986 6.00617 4.67546C6.91817 3.23866 7.57737 2.19866 8.68457 2.01626C10.659 1.68666 11.4078 3.24506 12.0094 4.49626C12.195 4.88026 12.3838 5.27706 12.5982 5.60986C14.275 8.22106 15.7278 9.44986 15.7406 9.46266C15.9454 9.63226 15.971 9.93626 15.8014 10.1379C15.7054 10.2531 15.571 10.3107 15.4334 10.3107L15.4398 10.3139Z"
				fill={color}
			/>
			<path
				d="M2.91214 13.792C2.73614 13.792 2.59214 13.648 2.59214 13.472V12.1152C2.59214 11.9392 2.73614 11.7952 2.91214 11.7952C3.08814 11.7952 3.23214 11.9392 3.23214 12.1152V13.472C3.23214 13.648 3.08814 13.792 2.91214 13.792Z"
				fill={color}
			/>
			<path
				d="M5.8114 13.8371C5.6354 13.8371 5.49139 13.6931 5.49139 13.5171V10.4451C5.49139 10.2691 5.6354 10.1251 5.8114 10.1251C5.9874 10.1251 6.13139 10.2691 6.13139 10.4451V13.5171C6.13139 13.6931 5.9874 13.8371 5.8114 13.8371Z"
				fill={color}
			/>
			<path
				d="M8.71065 13.7918C8.53465 13.7918 8.39065 13.6478 8.39065 13.4718V9.02061C8.39065 8.84461 8.53465 8.70061 8.71065 8.70061C8.88665 8.70061 9.03065 8.84461 9.03065 9.02061V13.4718C9.03065 13.6478 8.88665 13.7918 8.71065 13.7918Z"
				fill={color}
			/>
			<path
				d="M11.6127 13.7922C11.4367 13.7922 11.2927 13.6482 11.2927 13.4722V10.7522C11.2927 10.5762 11.4367 10.4322 11.6127 10.4322C11.7887 10.4322 11.9327 10.5762 11.9327 10.7522V13.4722C11.9327 13.6482 11.7887 13.7922 11.6127 13.7922Z"
				fill={color}
			/>
			<path
				d="M14.512 13.792C14.336 13.792 14.192 13.648 14.192 13.472V12.1152C14.192 11.9392 14.336 11.7952 14.512 11.7952C14.688 11.7952 14.832 11.9392 14.832 12.1152V13.472C14.832 13.648 14.688 13.792 14.512 13.792Z"
				fill={color}
			/>
		</>
	);
}
